<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">
      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="名称">
              <a-input placeholder="请输入" v-model="where.keyword.name" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-button type="primary" @click="searchList" v-btnlimit="'数据字典-搜索'">搜索</a-button>
            <a-button :style="{ marginLeft: '8px' }" @click="clear">清空</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="pxkeji-right-box">
      <!-- <a-form :form="form">
        <a-row class="items">
          <a-col :span="24">
            <pxkeji-btn name="疾病种类" @click="diseaseType" style="margin-left:20px" type="primary"/>
            <pxkeji-btn name="地区档案" @click="areaArchives" style="margin-left:20px"  type="primary"/>
          </a-col>
        </a-row>
      </a-form>-->
      <!-- <pxkeji-btn
        name="添加"
        :roles="[]"
        class="pxkeji_basic_btn"
        @click="showInfo(0)"
        type="primary"
      />-->
      <pxkeji-btn
        name="批量启用"
        v-btnlimit="'数据字典-批量启用'"
        @click="batchEnable"
        v-if="selectRows.length>0"
        class="pxkeji_basic_btn"
      />
      <pxkeji-btn
        name="批量禁用"
        v-btnlimit="'数据字典-批量禁用'"
        @click="batchDisEnable"
        v-if="selectRows.length>0"
        class="pxkeji_basic_btn"
      />

      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :locale="{emptyText:'暂无数据'}"
      >
        <span slot="action" slot-scope="action">
          <pxkeji-btn name="修改" @click="showInfo(action)" size="small" type="primary" v-btnlimit="'数据字典-修改'"/>
          <a-divider type="vertical" />
          <pxkeji-btn name="数据" @click="showList(action)" size="small" type="dashed" v-btnlimit="'数据字典-数据'"/>
          <!-- <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item key="1">
                <pxkeji-btn
                  name="查看"
                  @click="showInfo(action,1)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                />
              </a-menu-item>
              <a-menu-item key="2">
                <pxkeji-btn
                  name="禁用"
                  @click="handleStatus(action.id,0)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                  v-if="action.status==1"
                />
                <pxkeji-btn
                  name="启用"
                  @click="handleStatus(action.id,1)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                  v-else
                />
              </a-menu-item>
              <a-menu-item key="3">
                <pxkeji-btn
                  name="删除"
                  @click="delInfo(action.id)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                />
              </a-menu-item>
            </a-menu>
            <a-button size="small" type="dashed">
              更多
              <a-icon type="down" />
            </a-button>
          </a-dropdown>-->
        </span>
      </a-table>
      <div class="totalbox" style="float: left;">
        <div>
          <span>共有：{{list.pagination.total}}条数据</span>
        </div>
      </div>
    </div>

    <a-modal
      :title="addedit.title"
      v-model="addedit.visible"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <Info :infos="addedit.info" @callbackMethod="save" />
    </a-modal>

    <!---子集-->
    <a-modal
       :title="itemListInfo.title"
      v-model="itemListInfo.visible"
      :footer="false"
      destroyOnClose
      width="80%"
      :maskClosable="false"
    >
      <itemList @callbackMethod="save" :infos="itemListInfo.info" />
    </a-modal>
  </div>
</template>
<script>
var that;
import Info from "./dictionaryInfo.vue";
import itemList from "./diseaseTypelist.vue"; //疾病类型
const columns = [
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "编号"
  },
  {
    dataIndex: "name",
    key: "name",
    align: "center",
    title: "名称",
    width: 200
  },
  {
    dataIndex: "description",
    key: "description",
    align: "center",
    title: "描述"
  },
  {
    title: "操作",
    key: "action",
    width: 200,
    align: "center",
    scopedSlots: { customRender: "action" }
  }
];
export default {
  name: "dictionarylist",
  data() {
    return {
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          name: ""
        }
      },
      selectRows: [], //选中项编号
      isloading: false,
      addedit: {
        title: "",
        info: {},
        id: 0,
        visible: false
      },
      itemListInfo: {
        title: "",
        info: {},
        id: 0,
        visible: false
      },
      info: { appointmentLogTodo: "" },
      isloading: false,
      disease: {
        //疾病类型
        visible: false
      },
      area: {
        //地区
        visible: false
      }
    };
  },
  components: {
    itemList,
    Info
  },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      this.GetList();
    });
  },
  watch: {
    selectRows: function() {
      //console.log("watch", val);
    }
  },
  methods: {
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    },
    toggle() {
      this.expand = !this.expand;
    },
    onTimeChange(date, dateString) {
      this.where.keyword.setTime = dateString;
    },
    GetList() {
      //获取列表
      this.isloading = true;
      this.clearRows();
      this.$api.dictionaries
        .pageList(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          this.where.keyword.name
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    showInfo(info) {
      //打开弹出框
      this.addedit.visible = true;
      this.addedit.title = info.id ? "编辑" : "新增";
      this.addedit.info = info;
    },
    showList(info) {
      //打开弹出框
      this.itemListInfo.visible = true;
      this.itemListInfo.title ='字典子集';
      this.itemListInfo.info = info;
    },
    /*批量启用 */
    batchEnable() {
      this.handleProhibit(this.selectRows.join(","), 1);
    },
    /*批量禁用 */
    batchDisEnable() {
      this.$confirm({
        title: "您确定要执行批量禁用的操作吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.handleProhibit(that.selectRows.join(","), 0);
        },
        onCancel() {}
      });
    },
    /**单个启用禁用 */
    handleStatus(ids, status) {
      if (status == 0) {
        this.$confirm({
          title: "您确定要执行禁用的操作吗?",
          okText: "确定",
          okType: "danger",
          cancelText: "我再想想",
          onOk() {
            that.handleProhibit(ids, 0);
          },
          onCancel() {}
        });
      } else {
        that.handleProhibit(ids, 1);
      }
    },
    /*禁用启用 */
    handleProhibit(ids, status) {
      that.isloading = true;
      that.$api.form
        .updateStatus(ids, status)
        .then(res => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            that.$message.success(res.errorMsg);
            that.GetList();
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    /**删除 */
    delInfo(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.form
            .removeById(id)
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {}
      });
    },
    //子组件传值
    save() {
      this.addedit.visible = false;
      this.itemListInfo.visible = false;
      this.GetList();
    },
    close() {
      this.$confirm({
        title: "提示",
        content: "您确定要禁用么",
        okText: "确认",
        cancelText: "取消"
      });
    },
    /**疾病种类 */
    diseaseType() {
      this.disease.visible = true;
    },
    /**地区档案 */
    areaArchives() {
      this.area.visible = true;
    },
    /**提交 */
    handleSubmit() {
      this.isloading = true;
      this.$api.system.setting
        .updateByName(
          "cn.pxkj.pojo.system.GlobalSetting",
          that.info.tokenExpire,
          that.info.payExpiretime,
          that.info.cashArrivalTime,
          that.info.autoReceiveDays,
          that.info.adReleaseDate,
          that.info.adReleaseTime,
          that.info.rechargeAmount,
          that.info.spendMoney,
          that.info.gainPoint,
          that.info.moneyToPoint,
          that.info.spendPoint,
          that.info.equalMoney,
          that.info.pointToMoney,
          that.info.getPointByGive,
          that.info.agentMessage,
          that.info.agentMessageTemplate,
          that.info.passwordMessage,
          that.info.passwordMessageTemplate,
          that.info.withdrawMessage,
          that.info.withdrawMessageTemplate,
          that.info.loginMessage,
          that.info.loginMessageTemplate,
          that.info.registerMessage,
          that.info.registerMessageTemplate,
          that.info.commonMessage,
          that.info.commonMessageTemplate,
          that.info.appUpdateDate,
          that.info.appUpdateTime,
          that.info.customerRoleId,
          that.info.agentRoleId,
          that.info.maxDistance,
          that.info.appointmentLogTodo,
          that.info.weightOption,
          that.info.defaultUnit
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.$message.success(res.errorMsg);
            this.GetData();
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    }
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
.items {
  /* margin: 15px 0; */
  border-bottom: 1px #e8e8e8 solid;
  padding: 20px 0;
  color: rgba(0, 0, 0, 0.85);
}
.selectStyle {
  width: 200px !important;
  display: inline-block;
  margin-left: 5px;
}
.rechargeIpt {
  width: 120px;
  margin: 0 20px 0 5px;
}
.costIpt {
  width: 180px;
  margin: 0 20px 0 5px;
}
.templateItem {
  float: left;
  margin-left: 10px;
  margin-right: 20px;
}
.temBtn {
  cursor: pointer;
  color: #1890ff;
}
.itemBtns .ant-btn-primary {
  margin: 0 5px;
}
</style>

